import React, { useState, useEffect } from 'react';
import { cleanSearch } from 'utils';
import PropTypes from 'prop-types';
import Loader from "components/Loader";
import ShelfProduct from "components/ShelfProduct";
import ShelfPaginator from "components/ShelfPaginator";
import PubSub from 'services/PubSub/';
import Error500 from "components/Error500";
import { withRouter } from 'react-router';
import queryString from "query-string";
import PlpEmpty from "components/Shelf/PlpEmpty";
import productAction from "actions/Product";
import RenderService from 'services/Render';
import ProductFactory from 'factories/Products';
import Sidebar from "components/Siderbar";
import { useIsMounted } from 'hooks';
import TagManagerService from "services/TagManager";
import style from './style.scss';//NOSONAR


let _isMounted = false;
let isCompletedLoaded = true;
let actions = [];
let filterService = null;
let quantity = 0;
let page = 0;

const getInitialState = () => {
    const data = RenderService.getRenderData();

    if(!(data && data.plp && data.plp.filters)){
        return {};
    }

    let products = false;

    if(data.plp.plp_products && data.plp.plp_products.resources){
        quantity = parseInt(data.plp.plp_products.resources.split('/')[1] || '0');
    }

    if(data.plp.plp_products && data.plp.plp_products.data && data.plp.plp_products.data[0]){
        products = data.plp.plp_products.data.map(product => ProductFactory.create(product));
    }

    return {
        products
    };
}

const Shelf = (props) => {
    const {searchTerm} = props;
    const initialState = getInitialState();
    const [isLoading, setIsLoading] = useState(!initialState.products);
    const products = initialState.products || props.products;
    const isMounted = useIsMounted();

    useEffect(() => {
        _isMounted = true;
        filterService = props.filter;

        page = 0;

        loadMore()

        return () => {
            quantity = 0;
            _isMounted = false;
        };
    }, []);

    useEffect(()=> {
        actions.push(PubSub.register('filter_change', () => {
            reset();
            loadMore();
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    const reset = () => {
        page = 0;
    }

    const loadMore = () => {
        if (_isMounted) {
            isCompletedLoaded = true;
            setIsLoading(true);
        }

        const servicePage = filterService ? filterService.getPage() : 0;
        page = page ? page : servicePage;

        getProducts(page).then((results) => {
            if(!isMounted.current) return false;

            if(searchTerm && results && results.redirect){
                props.history.replace(results.redirect.replace('https://www.jumbo.cl', ''));
                TagManagerService.interaction(searchTerm, props.history.location.pathname, 'Redirect SearchBox')
                return false;
            }

            if(searchTerm && !(results && results.data && results.data.length > 0) && (filterService.specifications.length === 0 && filterService.brands.length === 0)){
                const search = searchTerm ? `?ft=${searchTerm}` : '';
                props.history.replace(`/Sistema/busquedavacia${search}`);
                return false;
            }

            if(results.quantity){
                quantity = results.quantity;
            } else {
                quantity = results && !results.data.status && !results.error && results.resources ? parseInt(results.resources.split('/')[1]) : quantity;
            }
            let total = (quantity > 0) ? Math.ceil(quantity / 40) : 0;

            if(total > 0 && page > total) {
                setPage(total);
            }

            const { search } = filterService;

            if (search && results && results.data && results.data.length === 1 && page === 1) {
                props.history.replace(`/${results.data[0].linkText}/p`);
            } else {
                _renderProds(results);
            }
        });

    }

    const _renderProds = (result) => {
        if(!result){
            isCompletedLoaded = false;
        }

        _applyProducts();
    }

    const getProducts = (_page) => {
        let {pathname, search} = props.location;
        const params = props.match.params;

        if(searchTerm) return productAction.getSearchProducts(searchTerm, _page, search, params);

        if (_page) {
            let params = queryString.parse(search);

            params.page = _page;

            if (params.ft) {
                params.ft = cleanSearch(params.ft);
            }

            search = '?' + queryString.stringify(params);
        }

        return productAction.getShelfProducts(pathname + search);
    }

    const _applyProducts = () => {
        props.changeQuantity(quantity);

        if (_isMounted) {
            setIsLoading(false);
        }
    }

    const setPage = (paramPage) => {
        if(!filterService) return false;
        filterService.setPage(paramPage);
        page = paramPage;
        loadMore();
    }

    const tagTitle =  filterService ? filterService.getPromoName(props.title) : '';
    const totalPages = (quantity > 0) ? (quantity / 40) : 0;

    return (
        <div className="shelf-wrapper">
            <Sidebar filters={props.filters} specifications={props.specifications} filter={props.filter}/>
            <div className="shelf-products-wrap">
                {products.length > 0 && <div className="shelf-content">
                    {!isLoading && <ul className="shelf-list">
                        {products.map((product, i) => {
                            const item = product.items[0] || product.item;
                            const gtmData = {
                                'name': product.productName,
                                'id': item.itemId,
                                'refId': item.referenceId[0].Value,
                                'price': item.prices.regular,
                                'brand': product.brand,
                                'category': product.categories[0] || '',
                                'variant': '',
                                'list': tagTitle,
                                'position': (product.pos || product.pos === 0) ? product.pos : i,
                                'type': 'impression-plp'
                            };

                            return (<li className="shelf-item" key={product.productId}>
                                <ShelfProduct product={product} position={i} listTitle={tagTitle} gtmData={gtmData}/>
                            </li>)
                        })}
                    </ul>}
                </div>}

                {(isCompletedLoaded && (products.length === 0) && !isLoading) && <PlpEmpty/>}
                {!isCompletedLoaded && products.length === 0 && <Error500/>}
                {!isCompletedLoaded && products.length > 0 && <div className='shelf-not-loaded'>
                    No se cargaron todos los productos solicitados. <button className='shelf-not-loaded-btn'>Intenta nuevamente</button>
                </div>}
                {isLoading &&
                <div className="shelf-list-loader">
                    <Loader />
                </div>}
                {(!isLoading && products.length > 0 && (products.length < quantity)) && <ShelfPaginator pages={totalPages} setPage={setPage} currentPage={Number(page)}/>}
            </div>

        </div>
    )

};

Shelf.propTypes = {
    filter: PropTypes.object,
    categories: PropTypes.array,
    title: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    products: PropTypes.array,
    changeQuantity: PropTypes.func
};

export default withRouter(Shelf);
